import { motion } from 'framer-motion';
import { FC, PropsWithChildren } from 'react';
const visualizeElementsAndSpacing = false;
const borderClassToVisualizeElementsAndSpacing = visualizeElementsAndSpacing
  ? 'border-white border'
  : '';
const spacingConfig = {
  padding: 'p-0 top-0 bottom-0 left-0 right-0',
};
const sizingConfig = {
  width: 'w-full',
  height: 'h-full',
};
const colorConfig = {
  background: 'bg-background/40',
  transparentBackground: 'bg-transparent',
};
const roundednessConfig = {
  roundedness: 'rounded-none',
};
interface Props extends PropsWithChildren {
  onClick?: () => void;
  isTransparent?: boolean;
  className?: string;
}
const Overlay: FC<Props> = ({
  children,
  onClick,
  isTransparent = false,
  className = '',
}) => {
  return (
    <motion.div
      className={`
        z-10 fixed flex justify-center items-center 
        ${sizingConfig.width} 
        ${sizingConfig.height} 
        ${
          isTransparent
            ? colorConfig.transparentBackground
            : colorConfig.background
        } 
        ${spacingConfig.padding} 
        ${roundednessConfig.roundedness} 
        ${borderClassToVisualizeElementsAndSpacing} 
        ${className}
      `}
      onClick={onClick}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {children}
    </motion.div>
  );
};
export default Overlay;
